import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { PedidoLote } from 'src/app/models/pedido-lote';
import { Produto } from 'src/app/models/produto';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { LoteProdutoService } from 'src/app/services/lote-produto.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-pedidos-lote-modal',
  templateUrl: './pedidos-lote-modal.component.html',
  styleUrls: ['./pedidos-lote-modal.component.scss']
})
export class PedidosLoteModalComponent implements OnInit, OnDestroy {

  // variáveis
  // produtos: Produto[] = [];
  pedidos: PedidoLote[] = [];

  // 0 - lote | 1 - reserva
  tipo = 0;

  lote;
  produto: Produto = new Produto();

  total = 0;

  titulo = '';

  mostrarCodErp = false;

  verExcel = false;

  idFornecedor;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(private loteProdutoService: LoteProdutoService, public utilitarioService: UtilitarioService, private premissasService: PremissasService,
    private globalService: GlobalService,
    private router: Router, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private produtoService: ProdutoService,
    public dialogRef: MatDialogRef<PedidosLoteModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  async ngOnInit() {

    this.verExcel = (await this.globalService.consultaUsuario()).verExcel;

    this.buscarMostrarCodErp();

    this.lote = this.data.lote;
    this.produto = this.data.produto;
    this.tipo = this.data.tipo;
    this.idFornecedor = this.data.idFornecedor;

    if (this.tipo == 0) {
      this.titulo = 'Pedidos do Lote ' + this.lote;
      this.buscarPedidos();
    } else {
      this.titulo = 'Pedidos da Reserva';
      this.buscarPedidosReserva();
    }

  }

  buscarPedidos() {
    this.carregandoService.mostra('buscarPedidos');

    this.loteProdutoService.consultarPedidos(this.lote, this.produto.idProduto, this.idFornecedor).subscribe(dados => {
      this.pedidos = dados;

      this.calcularTotal();

      this.carregandoService.esconde('buscarPedidos');
    }, (erro) => {
      this.carregandoService.esconde('buscarPedidos');
      this.notificacaoService.erro(erro);
    });
  }

  buscarPedidosReserva() {
    this.carregandoService.mostra('buscarPedidosReserva');

    this.produtoService.consultarPedidosDaReserva(this.produto.idProduto, this.idFornecedor).subscribe(dados => {
      this.pedidos = dados;

      this.calcularTotal();

      this.carregandoService.esconde('buscarPedidosReserva');
    }, (erro) => {
      this.carregandoService.esconde('buscarPedidosReserva');
      this.notificacaoService.erro(erro);
    });
  }

  calcularTotal() {
    if (this.pedidos !== null && this.pedidos !== undefined) {
      this.pedidos.forEach(p => this.total += p.qtd);
    }
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {

  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra('buscarMostrarCodErp');
    this.premissasService.consultarMostrarCodErp().subscribe(f => {
      this.mostrarCodErp = f.valor;
      this.carregandoService.esconde('buscarMostrarCodErp');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarCodErp');
      this.notificacaoService.erro(erro);
    });
  }

  exportar() {

    if (this.tipo === 0) {
      this.carregandoService.mostra('exportarPedidosDoLote');
      this.loteProdutoService.exportarPedidosDoLote(this.lote, this.produto.idProduto, this.idFornecedor).subscribe(arq => {
        this.utilitarioService.saveBlob(arq, 'Pedidos_do_lote.xlsx');
        this.carregandoService.esconde('exportarPedidosDoLote');
      }, (erro) => {
        this.carregandoService.esconde('exportarPedidosDoLote');
        this.notificacaoService.erro(erro);
      });
    } else {
      this.carregandoService.mostra('exportarPedidosDaReserva');
      this.produtoService.exportarPedidosDaReserva(this.produto.idProduto, this.idFornecedor).subscribe(arq => {
        this.utilitarioService.saveBlob(arq, 'Pedidos_da_reserva.xlsx');
        this.carregandoService.esconde('exportarPedidosDaReserva');
      }, (erro) => {
        this.carregandoService.esconde('exportarPedidosDaReserva');
        this.notificacaoService.erro(erro);
      });
    }
  }

}
